import React from 'react';
import { Translate } from 'react-jhipster';

import { NavItem, NavLink, NavbarBrand } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
library.add(faFileAlt);

export const BrandIcon = props => (
  <div {...props} className="brand-icon">
    <img src="content/images/logo.png" alt="Logo" />
  </div>
);

export const Brand = () => (
  <NavbarBrand tag={Link} to="/foreigner-residence" className="brand-logo">
    <BrandIcon />
    <span className="brand-title">
      <Translate contentKey="global.title">Foreigner Residence</Translate>
    </span>
    {/* <span className="navbar-version">{VERSION.toLowerCase().startsWith('v') ? VERSION : `v${VERSION}`}</span> */}
  </NavbarBrand>
);

export const Home = () => (
  <NavItem>
    <NavLink tag={Link} to="/" className="d-flex align-items-center">
      <FontAwesomeIcon icon="home" className="me-2" />
      <span>
        <Translate contentKey="global.menu.home">Home</Translate>
      </span>
    </NavLink>
  </NavItem>
);

export const FactChecking = () => (
  <NavItem>
    <NavLink tag={Link} to="/fact-checking" className="d-flex align-items-center">
      <FontAwesomeIcon icon="tasks" className="me-2" />
      <span>
        <Translate contentKey="global.menu.entities.factChecking">Fact Checking</Translate>
      </span>
    </NavLink>
  </NavItem>
);

export const FactCheckingReport = () => (
  <NavItem>
    <NavLink tag={Link} to="/fact-checking-report" className="d-flex align-items-center">
      <FontAwesomeIcon icon="file-alt" className="me-2" />
      <span>
        <Translate contentKey="global.menu.entities.Report">Report</Translate>
      </span>
    </NavLink>
  </NavItem>
);

export const ForeignerResidence = () => (
  <NavItem>
    <NavLink tag={Link} to="/foreigner-residence" className="d-flex align-items-center">
      <FontAwesomeIcon icon="tasks" className="me-2" />
      <span>
        <Translate contentKey="global.menu.entities.foreignerResidence">Foreigner Residence</Translate>
      </span>
    </NavLink>
  </NavItem>
);

export const ForeignerResidenceReport = () => (
  <NavItem>
    <NavLink tag={Link} to="/foreigner-residence-report" className="d-flex align-items-center">
      <FontAwesomeIcon icon="file-alt" className="me-2" />
      <span>
        <Translate contentKey="global.menu.entities.Report">Report</Translate>
      </span>
    </NavLink>
  </NavItem>
);
